module.exports = __webpack_public_path__ + "img/bag.e283175a.svg";